<template>
    <div class="bo-mode-input-number">
        <bo-dropdown-menu
            v-if="editable"
            :value="options"
            :default="selected"
            :dropdownStyle="dropdownStyle"
            @change="changedSelectedOption"
        >
            <template #selected-item="slotProps">
                <template v-if="slotProps.item">
                    <i
                        v-if="slotProps.item.icon"
                        :class="slotProps.item.icon"
                    ></i>
                    <span v-else-if="slotProps.item.badge">{{
                        slotProps.item.badge
                    }}</span></template
                ></template
            ><template #item="slotProps"
                ><i v-if="slotProps.item.icon" :class="slotProps.item.icon"></i>
                <span v-else-if="slotProps.item.badge">{{
                    slotProps.item.badge
                }}</span>
                <span>{{ slotProps.item.label }}</span></template
            >
        </bo-dropdown-menu>
        <template v-else>
            <template v-if="selected">
                <i v-if="selected.icon" :class="selected.icon"></i>
                <span v-else-if="selected.badge">{{ selected.badge }}</span>
            </template>
        </template>
        <bo-cell-number
            :meta="meta"
            :editable="editable"
            :id="id"
            :value="value"
            :inputStyle="inputStyle"
            @change="changedValue"
        >
        </bo-cell-number>
    </div>
</template>

<script>
import boDropdownMenu from "../bo-dropdown-menu.vue";
import boCellNumber from "@/bo-datatable/bo-cell-number.vue";
export default {
    components: { boDropdownMenu, boCellNumber },
    props: {
        meta: {
            type: Object,
            default: () => ({}),
        },
        editable: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            default: "",
        },
        value: {
            type: Number,
            default: 0,
        },
        inputStyle: {
            type: String,
            default: "",
        },
        options: {
            type: Array,
            default: [],
        },
        selected: {
            type: Object,
            default: null,
        },
        dropdownStyle: {
            type: String,
            default: "icon-selection",
        },
    },

    computed: {},

    methods: {
        changedValue(value) {
            this.$emit("value_change", value);
        },
        changedSelectedOption(value) {
            this.$emit("selected_change", value);
        },
    },
};
</script>